import API from '../../api';
import { toast } from 'react-toastify';

const API_URL = '/api/customers';

const sendEmailAPI = async (data, setLoading, reset) => {
  try {
    const response = await API.post(`${API_URL}/forgot-password`, data);
    setLoading(false);
    toast.success(response.data.message);
    reset();
  } catch (error) {
    setLoading(false);
    toast.error(error?.response?.data?.error?.message ?? error?.message);
  }
};

export default sendEmailAPI;
